import { ElementRef } from '@angular/core';

export function host(element: ElementRef): HTMLElement {
  return element.nativeElement as HTMLElement;
}
